import React from 'react';
import { motion } from 'framer-motion';
import { Button } from '../ui/Button';
import { CHECKOUT_BASIC, CHECKOUT_PREMIUM } from '../../data/content';
import { trackPixelEvent } from '../../utils/metaPixel';
export function Pricing() {
  return <section id="pricing" className="py-20 relative scroll-mt-20" data-id="element-201" data-mp="3bqryyv758rwo">
      <div className="container mx-auto px-4" data-id="element-202" data-mp="3gjuvnc77whh3">
        <div className="text-center mb-16" data-id="element-203" data-mp="3gkmh3u73oytn">
          <h2 className="text-4xl md:text-5xl font-display font-bold text-ink mb-4" data-id="element-204" data-mp="3linxu8h20m1y">
            ELEGÍ TU MEGA PACK
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-5xl mx-auto items-stretch" data-id="element-205" data-mp="3plkngj50hife">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="p-8 rounded-3xl bg-surface border border-line flex flex-col h-full" data-id="element-206" data-mp="3ughtriawpdol">
            <div className="mb-6" data-id="element-207" data-mp="252uvxvijj0d1">
              <h3 className="text-2xl font-bold text-ink mb-2 flex items-start gap-2" data-id="element-208" data-mp="253wfyphjax6w">
                <span aria-hidden="true" data-id="element-209" data-mp="1bcb8vk6bpi4y">📗</span> MEGA PACK COCINA LISTA
              </h3>
              <p className="text-pistachio-700 font-medium" data-id="element-210" data-mp="16j8dd6hzjym4">6 Tomos + 6 Bonos</p>
            </div>

            <p className="text-muted text-sm mb-8 flex-grow" data-id="element-211" data-mp="11lqeya1lh1sd">
              <span className="font-semibold text-ink" data-id="element-212" data-mp="xjli72funp1i">Ideal para:</span> Empezar el sistema
              completo de alimentación semanal
            </p>

            <div className="mb-8" data-id="element-213" data-mp="1u8t7mljlaiap">
              <div className="text-muted/70 line-through text-lg font-medium mb-1" data-id="element-214" data-mp="1paret8wd34m1">
                $52.000 ARS
              </div>
              <div className="text-5xl font-display font-bold text-ink flex items-baseline gap-2" data-id="element-215" data-mp="1l7v3m395ias4">
                $19.990{' '}
                <span className="text-xl text-muted font-sans font-medium" data-id="element-216" data-mp="1g9jtrsiuw09w">ARS</span>
              </div>
              <p className="text-xs text-muted mt-2" data-id="element-217" data-mp="9ro9vlblzf55">pago único · acceso inmediato</p>
            </div>

            <Button size="lg" fullWidth variant="secondary" href={CHECKOUT_BASIC} onClick={() => trackPixelEvent('InitiateCheckout', {
            content_name: 'Mega Pack Cocina Lista',
            value: 19990,
            currency: 'ARS'
          })} data-id="element-218" data-mp="4wr5irp9xtyl">
              → QUIERO MI MEGA PACK
            </Button>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="p-8 rounded-3xl bg-pistachio-100 border-2 border-pistachio-400 flex flex-col h-full relative shadow-[0_16px_40px_-24px_rgba(104,143,58,0.5)]" data-id="element-219" data-mp="3jp59uz2ig7nv">
            <div className="absolute -top-4 left-1/2 -translate-x-1/2 bg-pistachio-400 text-pistachio-900 text-xs font-bold uppercase tracking-widest py-1 px-4 rounded-full flex items-center gap-1 shadow-sm whitespace-nowrap" data-id="element-220" data-mp="30rlwxkcxm4w6">
              <span aria-hidden="true" data-id="element-221" data-mp="2m5owj3bhk7kt">⭐</span> MÁS ELEGIDO
            </div>

            <div className="mb-6 mt-2" data-id="element-222" data-mp="2h6vecxl97seb">
              <h3 className="text-2xl font-bold text-ink mb-2 flex items-start gap-2" data-id="element-223" data-mp="2h86kv5633e94">
                <span aria-hidden="true" data-id="element-224" data-mp="2v7ejnwyc4kcs">🏆</span> MEGA PACK + SISTEMA TOTAL
              </h3>
              <p className="text-pistachio-800 font-medium" data-id="element-225" data-mp="2r2os2kaplrxo">
                6 Tomos + 6 Bonos + Método Cocina Impecable
              </p>
            </div>

            <p className="text-ink/80 text-sm mb-8 flex-grow" data-id="element-226" data-mp="305g4onfbmtqw">
              <span className="font-semibold text-ink" data-id="element-227" data-mp="302tyar462ka9">Ideal para:</span> La solución
              completa de alimentación y hogar
            </p>

            <div className="mb-8" data-id="element-228" data-mp="39uhkodlv9b4v">
              <div className="text-muted/70 line-through text-lg font-medium mb-1" data-id="element-229" data-mp="39vj71e8c1k1w">
                $71.000 ARS
              </div>
              <div className="text-5xl font-display font-bold text-ink flex items-baseline gap-2" data-id="element-230" data-mp="3ivfsl6zfe2sq">
                $27.990{' '}
                <span className="text-xl text-muted font-sans font-medium" data-id="element-231" data-mp="1h71qnkn4imfl">ARS</span>
              </div>
              <p className="text-xs text-muted mt-2" data-id="element-232" data-mp="1m4bckqbb0fyo">pago único · acceso inmediato</p>
            </div>

            <Button size="lg" fullWidth href={CHECKOUT_PREMIUM} onClick={() => trackPixelEvent('InitiateCheckout', {
            content_name: 'Mega Pack + Sistema Total',
            value: 27990,
            currency: 'ARS'
          })} data-id="element-233" data-mp="1qx4ihhiiducc">
              → QUIERO EL SISTEMA TOTAL
            </Button>
          </motion.div>
        </div>
      </div>
    </section>;
}